import {InputEvent, GraphObject, Spot, Node} from 'gojs';

import {APPLICATION_GRAPH_NODE_RADIUS} from 'src/util/gojs/constants';

import {bindLocation} from './utils';
import {highlightConnections} from './events';
import {makeNodeShape} from './shape';
import {makePanel} from './panel';

const {make} = GraphObject;

// If we use 0.5, gojs treats it as a special
// case and stops segments at the edge of the node
const CENTER_HACK_VALUE = 0.5001;

const CENTER = CENTER_HACK_VALUE;

export const makeNodeTemplate = () => make(
    Node,
    'Auto',
    {
      selectionAdorned: false,
      // deletable: false,
      click: handleClickNode,
      fromSpot: new Spot(CENTER, CENTER),
      toSpot: new Spot(CENTER, CENTER),
      toShortLength: APPLICATION_GRAPH_NODE_RADIUS,
      fromShortLength: APPLICATION_GRAPH_NODE_RADIUS,
      fromEndSegmentLength: 0,
      toEndSegmentLength: 0,
    },
    bindLocation(),
    makeNodeShape(),
    makePanel(),
);

export const handleClickNode = (_e: InputEvent, graphObject: GraphObject) => {
  if (!(graphObject instanceof Node)) {
    return;
  }
  highlightConnections(graphObject);
};
